import type { ReactNode } from "react";

type FieldRequirement = {
  required: boolean;
  text?: string;
};

export function FieldBadge({ required, text }: FieldRequirement) {
  return (
    <span className="ui-field-badge" data-required={required}>
      {text ?? (required ? "必須" : "任意")}
    </span>
  );
}

export function FieldLabel({
  children,
  required,
  requirementText,
  className,
}: {
  children: ReactNode;
  required?: boolean;
  requirementText?: string;
  className?: string;
}) {
  return (
    <span className={["ui-field-label", className].filter(Boolean).join(" ")}>
      {children}
      {required !== undefined && (
        <FieldBadge required={required} text={requirementText} />
      )}
    </span>
  );
}
